import { Col, Form, Modal } from "react-bootstrap";
import FloatingInput from "../compoment/ui/FloatingInput";
import Loader from "../compoment/ui/Loader";
import Email from "../compoment/icon/Email";
import LogoBlack from "./../assets/img/MOSIDA-black.png";
import { FormEvent, useEffect, useState } from "react";
import { useForm } from "../constants/useForm";
import { toast } from "react-toastify";
import { authService } from "./auth/authService";
import { ForgotPasswordValues } from "./auth/types";
import { validateForgotPassword } from "./auth/validation";

interface ForgotPasswordModalProps {
  show: boolean;
  onHide: () => void;
  props?: Record<string, unknown>;
  setSignupModal?: React.Dispatch<React.SetStateAction<boolean>>;
  setSigninModal?: React.Dispatch<React.SetStateAction<boolean>>;
  setForgotPasswordModal?: React.Dispatch<React.SetStateAction<boolean>>;
  setVerificationModal?: React.Dispatch<React.SetStateAction<boolean>>;
  onOpenSignup?: () => void;
  onOpenSignin?: () => void;
  onOpenVerification?: () => void;
}

const ForgotPasswordModal: React.FC<ForgotPasswordModalProps> = ({
  show,
  onHide,
  setSignupModal,
  setSigninModal,
  props,
  setForgotPasswordModal,
  onOpenSignup,
  onOpenSignin,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [linkSent, setLinkSent] = useState(false);

  const { values, handleChange, resetForm } = useForm({
    email: "",
  });

  const typedValues = values as ForgotPasswordValues;

  useEffect(() => {
    if (show) return;
    setLinkSent(false);
    setIsSubmitting(false);
    resetForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- reset only when modal closes
  }, [show]);

  const goToSignin = () => {
    setLinkSent(false);
    onOpenSignin?.();
    setForgotPasswordModal?.(false);
    setSigninModal?.(true);
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isSubmitting) return;

    const validationError = validateForgotPassword(typedValues);
    if (validationError) return toast.error(validationError);

    setIsSubmitting(true);
    try {
      await authService.forgotPassword(typedValues);
      setLinkSent(true);
    } catch {
      toast.error("Failed to send reset link. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {isSubmitting && <Loader />}
      <Modal
        className="mosidaModal signinModal"
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={onHide}
      >
        <Modal.Header className="pb-0" closeButton={!linkSent} />
        <Modal.Body className="py-5">
          <Col md={10} className="mx-auto">
            <div className="text-center mb-4 pb-md-2 mt-5">
              <img
                className="pointer"
                style={{ width: 140 }}
                src={LogoBlack}
                alt="MOSIDA logo"
              />
            </div>

            {linkSent ? (
              <>
                <div className="sectionHeading text-center mb-2 pb-3">
                  Password reset link sent.
                </div>
                <p className="text-muted text-center mb-4 pb-3">
                  Please check your email.
                </p>
                <button
                  className="btnPrimary w-100 sqaure"
                  type="button"
                  onClick={goToSignin}
                >
                  Continue
                </button>
              </>
            ) : (
              <>
                <div className="sectionHeading mb-0 pb-2">
                  Forgot your password?
                </div>
                <p className="text-muted mb-4 pb-3">{`Enter your email and we’ll send you a password reset link.`}</p>
                <Form onSubmit={handleSubmit}>
                  <FloatingInput
                    placeholder="example@gmail.com"
                    label="E-mail"
                    icon={Email}
                    type="text"
                    name="email"
                    value={typedValues.email}
                    autoComplete="email"
                    onChange={handleChange}
                  />
                  <button
                    className="btnPrimary w-100 sqaure"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Continue
                  </button>
                </Form>

                <div className="dontHaveAccount mt-4">
                  {`Don’t have an account?`}{" "}
                  <span
                    className="text-primary"
                    onClick={() => {
                      onOpenSignup?.();
                      setForgotPasswordModal?.(false);
                      setSignupModal?.(true);
                    }}
                  >
                    Sign up
                  </span>
                </div>
              </>
            )}
          </Col>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ForgotPasswordModal;
